import {createRoot} from 'react-dom/client';
import React, {StrictMode} from 'react'

import App from './App';
import { ApptekstProvider } from "./apptekst-context";

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
    <ApptekstProvider appnavn={['timebestilling']}>
        <StrictMode>
           <App />
        </StrictMode>
    </ApptekstProvider>
);